import { useEffect } from 'react';

import { IconButton } from '@material-ui/core';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import { navigate } from '@reach/router';
import { useDispatch, useSelector } from 'react-redux';

import { useWorkshops } from '../../../hooks/useWorkshops';
import { getLocations } from '../../../provider/models/mapModel';
import {
  clearedData,
  downloadedData,
  selectedLocation,
} from '../../../store/actions';
import { serviceTypes } from '../../../store/initData/services';
import { env } from '../../../utils/env';
import AccordionWithSearch from '../../AccordionWithSearch';
import styles from './FilterMenu/FilterMenu.module.scss';

type SearcherProps = {
  onClose: () => void;
};

export const Searcher = ({ onClose }: SearcherProps) => {
  const dispatch = useDispatch();

  const currentService = useSelector((store: any) => store.state.service);
  const currentCity = useSelector((store: any) => store.state.city);
  const currentAge = useSelector((store: any) => store.state.age);
  const isWorkshopService = currentService.value === serviceTypes.workshop;
  const ageLinkValue = currentAge?.value || 0;
  const currentRobotType = useSelector(
    (store: any) => store.state.robot?.value,
  );

  const currentFranchise = useSelector(
    (store: any) => store.state.city?.franchise,
  );

  const { workshops } = useWorkshops({
    franchiseId: currentCity.value,
    levelId: currentRobotType,
  });

  useEffect(() => {
    if (workshops) {
      dispatch(downloadedData(workshops, 'workshops'));

      navigate(
        `${env.PUBLIC_URL}/${currentService.value}/${currentFranchise.id}` +
          (isWorkshopService ? `/${ageLinkValue}/${currentRobotType}` : ``),
      );
      dispatch(clearedData('state', 'locationId'));
    }
  }, [
    ageLinkValue,
    currentFranchise.id,
    currentRobotType,
    currentService.value,
    dispatch,
    isWorkshopService,
    workshops,
  ]);

  const currentRobot = useSelector((store: any) => store.state.robot);

  const currentLocationId = useSelector<DefaultRootState>(
    (store) => store.state.locationId,
  );

  const options = getLocations(workshops).map((ws) => ({
    subText: ws.physical_address,
    text: ws.location_title,
    value: ws.workshop_location_id,
  }));

  const selected = options.find((ws) => ws.value === currentLocationId);

  const handleSelectLocation = (item: (typeof options)[number]) => {
    dispatch(selectedLocation(item.value));
    navigate(
      `${env.PUBLIC_URL}/${currentService.value}/${currentFranchise.id}` +
        (isWorkshopService ? `/${ageLinkValue}/${currentRobot.value}` : ``) +
        `/${item.value}`,
    );
    onClose();
  };

  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <div className={styles.heading__text}>Wybierz lokalizację</div>
        <IconButton
          aria-label="close"
          size="small"
          style={{
            border: '1px solid var(--color-main-orange)',
            padding: 0,
            color: 'var(--color-main-orange)',
            marginLeft: '20px',
          }}
          onClick={onClose}
        >
          <CloseOutlinedIcon fontSize="small" />
        </IconButton>
      </div>
      <div className={styles.entryContainer}>
        <AccordionWithSearch
          small={false}
          alwaysExpanded
          data={options}
          selected={selected}
          onClick={handleSelectLocation}
          placeholder="Wpisz nazwę lokalizacji"
        />
      </div>
    </div>
  );
};
